import { defaultOptions, TIMED_OUT_ERROR } from './constants';
/**
 * This function polls a getter function and returns it's value when it becomes defined.
 *
 * @param getter - The getter function.
 * @param options - Specify how to poll. `times` sets the number of times to poll, `interval` specifies how long to wait between polls.
 * @returns - Promise with the value.
 */
const waitFor = (getter, options = defaultOptions) => {
    let counter = 0;
    return new Promise((resolve, reject) => {
        const intervalId = setInterval(() => {
            var _a;
            if (counter < ((_a = options.times) !== null && _a !== void 0 ? _a : defaultOptions.times)) {
                const gottenObject = getter();
                if (gottenObject !== undefined) {
                    clearInterval(intervalId);
                    resolve(gottenObject);
                }
                else {
                    counter += 1;
                }
            }
            else {
                clearInterval(intervalId);
                reject(new Error(TIMED_OUT_ERROR));
            }
        }, options.interval);
    });
};
export default waitFor;
//# sourceMappingURL=waitFor.js.map